import { render } from "./Banner.vue?vue&type=template&id=3b807cc6&scoped=true"
const script = {}

import "./Banner.vue?vue&type=style&index=0&id=3b807cc6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b807cc6"]])

export default __exports__